const log = () => (next: any) => async (action: any) => {
  if (action.type === "SHOW_ERROR") {
    console.error(action.payload.error.message);
  }
  next(action);
};

export default log;
